import apiClient from './apiClient'


const getBudgets = (tenant, projectId) => {
  return apiClient.get(`/${tenant}/Budget/${projectId}`)
}

const getBudgetByProjectIdById = (tenant, projectId, id) => {
  return apiClient.get(`/${tenant}/Budget/${projectId}/${id}`)
}

const getTotal = (tenant, projectId) => {
  return apiClient.get(`/${tenant}/Budget/${projectId}/Total`)
}

const createBudget = (tenant, projectId, budget) => {
  return apiClient.post(`/${tenant}/Budget/${projectId}`, budget)
}

const updateBudget = (tenant, projectId, budgetId, budget) => {
  return apiClient.put(`/${tenant}/Budget/${projectId}/${budgetId}`, budget)
}

const deleteBudget = (tenant, projectId, budgetId) => {
  return apiClient.delete(`/${tenant}/Budget/${projectId}/${budgetId}`)
}


export default {
  getBudgets,
  getBudgetByProjectIdById,
  getTotal,
  createBudget,
  updateBudget,
  deleteBudget
}
